__turbopack_context__.v({
  "button": "button-module__x0Fa7W__button",
  "button_disabled": "button-module__x0Fa7W__button_disabled",
  "button_error": "button-module__x0Fa7W__button_error",
  "button_full_width": "button-module__x0Fa7W__button_full_width",
  "button_icon": "button-module__x0Fa7W__button_icon",
  "button_large": "button-module__x0Fa7W__button_large",
  "button_medium": "button-module__x0Fa7W__button_medium",
  "button_secondary": "button-module__x0Fa7W__button_secondary",
  "button_small": "button-module__x0Fa7W__button_small",
});
